// extracted by mini-css-extract-plugin
export default {"pageContainer":"Prioridades_pageContainer__MkIA2","pageTitle":"Prioridades_pageTitle__JD3E1"};